import React from 'react';
import './footer.scss';
import { useSiteConfig } from '../../context/site-configs-context';

const Footer: React.FC = () => {
    const { footer } = useSiteConfig();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="app-footer">
            <p>&copy; {currentYear} {footer}.</p>
        </footer>
    );
};

export default Footer;
